

















import { Vue, Component } from 'vue-property-decorator'
import SvgPolygons from '~/components/SvgPolygons.vue'
import CoreHeader from '~/layouts/header.vue'
import CoreMenu from '~/layouts/menu.vue'
import CoreContent from '~/layouts/content.vue'
import CoreFooter from '~/layouts/footer.vue'
import { Route } from 'vue-router'

interface MenuType {
    path: string
    name: string
    icon: Array<string>
}

@Component({
    components: {
        SvgPolygons,
        CoreHeader,
        CoreMenu,
        CoreContent,
        CoreFooter
    }
})
export default class App extends Vue {
    private menu: Array<MenuType> = []

    get isDrawer(): boolean {
        return this.$store.getters.isDrawer
    }

    get isTransition(): boolean {
        return this.$store.getters.isTransition
    }

    get isNotIndex(): boolean {
        const route: Route | undefined = this.$route
        if (route && route?.name) {
            return route.name !== 'index'
        }
        return false
    }

    setDrawer(arg0: boolean): void {
        this.$store.dispatch('setDrawer', arg0)
    }

    closeMenu(): void {
        this.setDrawer(false)
    }

    mounted(): void {
        this.menu = [
            {
                path: '/home',
                name: 'home',
                icon: ['fas', 'home'],
            },
            {
                path: '/about',
                name: 'about',
                icon: ['fas', 'calendar-times'],
            },
            {
                path: '/training',
                name: 'training',
                icon: ['fas', 'dumbbell'],
            },
            {
                path: '/gallery',
                name: 'gallery',
                icon: ['fas', 'images'],
            },
            {
                path: '/contact',
                name: 'contact',
                icon: ['fas', 'envelope'],
            }
        ]
    }
}
